export default {
    GET_ALL_NOTIFCATION_SUCCESS: "GET_ALL_NOTIFCATION_SUCCESS",
    RECEIVE_NOTIFCATION: "RECEIVE_NOTIFCATION",
    MARK_ALL_AS_READ: "MARK_ALL_AS_READ",
    DISMISS_PUSH_NOTIFICATION:"DISMISS_PUSH_NOTIFICATION"
}